import { BrowserRouter as Router, Routes, Route, useLocation, Navigate, Outlet } from 'react-router-dom';
import ClienteComponent from "./app/pages/esteira/clienteComponent";
import EsteiraAtividades from "./app/pages/esteira/esteiraAtividades";
import PropostaEsteiraComponent from "./app/pages/esteira/propostaEsteiraComponent";
import PropostasComponent from "./app/pages/esteira/propostasComponent";
import PromotoraEmpregador from "./app/pages/origens-parametros/promotoraEmpregador";
import PromotoraInformacoesGerais from "./app/pages/origens/promotora/promotoraInformacoesGerais";
import MatrizComponent from './app/pages/origens/matriz/matrizComponent';
import OperadorComponent from "./app/pages/origens/operador/operadorComponent";
import PontoVendaComponent from "./app/pages/origens/pontoVenda/pontoVendaComponent";
import PromotoraComponent from "./app/pages/origens/promotora/promotoraComponent";
import SupervisorComponent from "./app/pages/origens/supervisor/supervisorComponent";
import OriginadorComponent from "./app/pages/origens/originador/originadorComponent"
import OrgaoComponent from "./app/pages/parametros/empregador/orgaoComponent";
import EmpregadorComponent from "./app/pages/parametros/empregador/empregadorComponent";
import EsteiraAlteracao from "./app/pages/parametros/esteira/esteiraAlteracao";
import EsteiraComponent from "./app/pages/parametros/esteira/esteiraComponent";
import EsteiraInclusao from "./app/pages/parametros/esteira/esteiraInclusao";
import FinanciamentoComponent from "./app/pages/parametros/financiamento/financiamentoComponent";
import FinanciamentoEmpregador from "./app/pages/parametros/financiamento/financiamentoEmpregador";
import FinanciamentoPromotora from "./app/pages/parametros/financiamento/financiamentoPromotora";
import MotivoComponent from "./app/pages/parametros/motivo/motivoComponent";
import ProdutoComponent from "./app/pages/parametros/produto/produtoComponent";
import CartaoComponent from "./app/pages/proposta/cartaoComponent";
import ParametrosTi from "./app/pages/sistema/parametrosTi";
import ParametrosGerais from "./app/pages/sistema/parametrosGerais";
import AlcadaEsteiraComponent from "./app/pages/sistema/alcadaEsteiraComponent";
import AnaliseRmcComponent from "./app/pages/esteira/analiseRmcComponent";
import ConsultaPH3AComponent from "./app/pages/back-office/bureau/consultaPH3AComponent";
import SerasaConsultaComponent from "./app/pages/back-office/bureau/serasaConsultaComponent";
import ConsultaPEPComponent from "./app/pages/back-office/bureau/consultaPEPComponent";
import ConsultaContratoComponent from "./app/pages/back-office/contrato/consultaContratoComponent";
import DetalheContratoComponent from "./app/pages/back-office/contrato/detalheContratoComponent";
import BaixaParcelaManualComponent from "./app/pages/back-office/lancamentos/baixaParcelaManualComponent";
import EstornoParcelaComponent from "./app/pages/back-office/lancamentos/estornoParcelaComponent";
import HistoricoFinanceiroComponent from "./app/pages/back-office/tabelas/historicoFinanceiro/historicoFinanceiroComponent";
import HistoricoFinanceiroInclusaoAlteracao from "./app/pages/back-office/tabelas/historicoFinanceiro/historicoFinanceiroInclusaoAlteracao";
import RoleInclusaoAlteracao from './app/pages/sistema/roleInclusaoAlteracao';

import ImportacaoAquisicao from "./app/pages/back-office/importacaoAquisicao/importacao-aquisicao";

import GestaoNotaFiscalComponent from "./app/pages/comissao/gestaoNotaFiscalComponent";
import EstornoComponent from './app/pages/comissao/gestaoEstornoComponent'; 
import NegociacoesComponent from './app/pages/comissao/gestaoNegociacoesComponent';
import ComissaoRegrasComponent from "./app/pages/comissao/comissaoRegrasComponent";
import ComissaoParametrosGeraisComponent from "./app/pages/comissao/comissaoParametrosGeraisComponent";
import FaturaGestaoComponent from "./app/pages/comissao/faturaGestaoComponent";
import TipoComissaoComponent from "./app/pages/comissao/tipoComissaoComponent";
import FinanceiroComponent from "./app/pages/comissao/financeiroComponent";
import RelatorioFaturasComponent from "./app/pages/comissao/relatorioFaturasComponent";

import RastreamentoCartaoProcessadoraCartao from "./app/pages/processadoraCartao/rastreioCartao";
import ConsultaLimiteProcessadoraCartao from "./app/pages/processadoraCartao/consultaLimite";
import SolicitacaoSegundaViaCartao from "./app/pages/processadoraCartao/segundaViaCartao";
import CancelamentoCartao from "./app/pages/processadoraCartao/cancelamentoConta";
import CancelamentoMovimentacao from "./app/pages/back-office/lancamentos/cancelamentoMovimentacao";
import EstornoOperacao from "./app/pages/back-office/lancamentos/estornoOperacao";
import ProrrogacaoVencimentoManualComponent from "./app/pages/back-office/lancamentos/prorrogacaoVencimentoManualComponent";
import ArquivoLoteDetalhe from "./app/pages/back-office/arquivoLote/arquivoLoteDetalhe";
import ArquivoLoteComponent from "./app/pages/back-office/arquivoLote/arquivoLoteComponent";
import FidcComponent from "./app/pages/back-office/tabelas/cessao/fidcComponent";
import FidcInlusaoAlteracao from "./app/pages/back-office/tabelas/cessao/fidcInclusaoAlteracao";
import LancamentoManual from "./app/pages/back-office/cessao/lancamentoManual";
import RemessaCessao from "./app/pages/back-office/cessao/remessaCessao";
import GerenciamentoCessao from "./app/pages/back-office/cessao/gerenciamentoCessao";
import RecompraManualComponent from "./app/pages/back-office/cessao/recompraManualComponent";
import OperacoesRealizadasComponent from "./app/pages/back-office/relatorios/operacoesRealizadasComponent";
import DeVencimentosComponent from "./app/pages/back-office/relatorios/deVencimentosComponent";
import MovimentacaoFinanceiraComponent from "./app/pages/back-office/relatorios/movimentacaoFinanceiraComponent";
import ContratosCedidosComponent from "./app/pages/back-office/relatorios/contratosCedidosComponent";
import ParcelasCedidasComponent from "./app/pages/back-office/relatorios/parcelasCedidasComponent";
import RemessaoLiquidacaoComponent from "./app/pages/back-office/lancamentos/remessaLiquidacaoComponent";
import ConsultaDocumentosComponent from "./app/pages/esteira/consultaDocumentosComponent";
import RetornoFluxoComponent from "./app/pages/esteira/retornoFluxoComponent";
import ProducaoAnaliticoComponent from "./app/pages/relatorios/producaoAnaliticoComponent";
import ProducaoSinteticoComponent from "./app/pages/relatorios/producaoSinteticoComponent";
import OrigensCadastradasComponent from "./app/pages/relatorios/origensCadastradasComponent";
import ClienteConsultaComponent from "./app/pages/cliente/clienteConsultaComponent";
import ClienteConsultaHistoricoComponent from "./app/pages/cliente/clienteConsultaHistoricoComponent";
import ClienteAprovarAtualizacaoComponent from "./app/pages/cliente/clienteAprovarAtualizacaoComponent";
import ClienteRelatorioComponent from "./app/pages/cliente/clienteRelatorioComponent";
import ComunicadosVigentesComponent from "./app/pages/comunicados/comunicadosVigentesComponent";
import ComunicadosTipoComponent from "./app/pages/comunicados/comunicadosTipoComponent";
import ComunicadosComponent from "./app/pages/comunicados/comunicadosComponent";
import ComunicadosInclusaoAlteracao from "./app/pages/comunicados/comunicadosInclusaoAlteracao";
import ComunicadosVigentesVisualizacao from "./app/pages/comunicados/comunicadosVisualizacao";
import UsuarioComponent from "./app/pages/sistema/usuarioComponent";
import CessaoComponent from "./app/pages/back-office/tabelas/cessao/cessaoComponent";
import UsuarioInclusaoAlteracao from "./app/pages/sistema/usuarioInclusaoAlteracao";
import MatrizInclusaoAlteracao from "./app/pages/origens/matriz/matrizInclusaoAlteracao";
import PromotoraInclusaoAlteracao from "./app/pages/origens/promotora/promotoraInclusaoAlteracao";
import SupervisorInclusaoAlteracao from "./app/pages/origens/supervisor/supervisorInclusaoAlteracao";
import OperadorInclusaoAlteracao from "./app/pages/origens/operador/operadorInclusaoAlteracao";
import PontoVendaInclusaoAlteracao from "./app/pages/origens/pontoVenda/pontoVendaInclusaoAlteracao";
import EmpregadorInclusaoAlteracao from "./app/pages/parametros/empregador/empregadorInclusaoAlteracao";
import ProdutoInclusaoAlteracao from "./app/pages/parametros/produto/produtoInclusaoAlteracao";
import FinanciamentoInclusaoAlteracao from "./app/pages/parametros/financiamento/financiamentoInclusaoAlteracao";
import OriginadorInclusaoAlteracao from "./app/pages/origens/originador/originadorInclusaoAlteracao";
import CessaoInclusaoAlteracao from "./app/pages/back-office/tabelas/cessao/cessaoInclusaoAlteracao";
import PrivateRoute from "./privateRoute";
import LoginComponent from "./app/pages/login/loginComponent";
import NavBar from './app/NavBar';
import Home from './app/pages/Home';
import ComunicadosConfirmacaoComponent from './app/pages/comunicados/comunicadosConfirmacaoComponent';
import ExtratoMensalComponent from './app/pages/relatorios/extratoMensalComponent';
import ReprovarPropostaComponent from './app/pages/esteira/reprovarPropostaComponent';
import UsuarioAlteracaoSenhaComponent from './app/pages/sistema/usuarioAlteracaoSenhaComponent';
import SemPermissao from './app/pages/SemPermissao';
import LogsComponent from './app/pages/sistema/logsComponent';
import LoginAlteracaoSenhaComponent from './app/pages/login/loginAlteracaoSenhaComponent';
import { Helmet } from 'react-helmet';
import { ThemeProvider } from 'styled-components';
import GlobalStyle from './AppStyles';
import { useEffect, useState } from 'react';
import { setAxiosErrorHandler } from './app/services/axiosConfig';
import CustomAlert from './app/shared/customAlert';
import ControleBloqueioComponent from './app/pages/esteira/controleBloqueio';
import FeriadosComponent from './app/pages/parametros/feriados/feriadosComponent';
import FeriadosInclusaoComponent from './app/pages/parametros/feriados/feriadosInclusaoComponent';
import FeriadosEdicaoComponent from './app/pages/parametros/feriados/feriadosEdicaoComponent';
import RelatorioFatorPriceComponent from './app/pages/relatorios/relatorioFatorPriceComponent';
import BancoComponent from './app/pages/parametros/banco/bancoComponent';
import BancoInclusaoAlteracao from './app/pages/parametros/banco/bancoInclusaoAlteracao';
import AlcadaInclusaoAlteracao from './app/pages/sistema/alcadaInclusaoAlteracao';
import GerenciadorRelatoriosComponent from './app/pages/back-office/relatorios/gerenciadorRelatoriosComponent';
import { useLayout, LayoutProvider  } from './contexts/LayoutContext';
import RegionalComponent from './app/pages/origens/regional/regionalComponent';
import RegionalInclusaoAlteracao from './app/pages/origens/regional/regionalInclusaoAlteracao';
import RoleInclusaoComponent from './app/pages/sistema/roleInclusaoComponent';
import ComercialComponent from './app/pages/origens/comercial/comercialComponent';
import ComercialInclusaoAlteracao from './app/pages/origens/comercial/comercialInclusaoAlteracao';
import IntegracaoComponent from './app/pages/back-office/integracoes/integracaoComponent';
import IntegracaoFormComponent from './app/pages/back-office/integracoes/integracaoFormComponent';
import ErroOriginador from './app/pages/error/OriginadorNaoEncontrado';
import RelatoriosPersonalizadosComponent from './app/pages/relatorios/relatoriosPersonalizadosComponent';
import RelatoriosPersonalizadosInclusaoAlteracao from './app/pages/relatorios/relatoriosPersonalizadosInclusaoAlteracao';
import Conciliacao from './app/pages/relatorios/conciliacao';
import PromotoraFinanciamento from './app/pages/origens-parametros/promotoraFinanciamento';
import GestaoDocComponent from './app/pages/esteira/gestaoDocComponent';
import BaixaParcelaFinanceiraManualComponent from './app/pages/back-office/lancamentos/baixaParcelaFinanceiraManualComponent';
import BaixaParcelaFinanceiraPorEmpregadorComponent from './app/pages/back-office/lancamentos/baixaParcelaFinanceiraPorEmpregadorComponent';
import RepactuaçãoParcelaComponent from './app/pages/back-office/lancamentos/repactuaçãoParcelaComponent';
import MovimentacaoBaixaFinanceiraComponent from './app/pages/back-office/relatorios/movimentacaoBaixaFinanceiraComponent';
import PropostaReemissaoCcbComponent from './app/pages/esteira/propostaReemissaoCcbComponent';


const ThemedLayout = () => {
    const { layout, loading } = useLayout();

    if (loading) {
        return <div>Aguarde...</div>;
    }

    const theme = {
        corPrincipal: layout.corPrincipal || '#5a8e91',
        corSecundaria: layout.corSecundaria || '#3d6062',
        corTexto: layout.corTexto || '#F1F1F1',
        corFundoHeader: layout.corCabecalho || '#282c34',
        corFundoTable: layout.corTabela || '#24393A'
    };

    return (
        <ThemeProvider theme={theme}>
            <GlobalStyle />
            <NavBar />
            <Outlet /> 
        </ThemeProvider>
    );
};

const PublicLayout = () => (
    <LayoutProvider>
        <Outlet />
    </LayoutProvider>
);


const App = () => {
    const [alert, setAlert] = useState<{ message: string, type: 'success' | 'warning' | 'error' } | null>(null);
    useEffect(() => {
        setAxiosErrorHandler((message, type) => {
            setAlert({ message, type });
        });
    }, []);

    return (
        <div style={{ width: '99%' }}>
            {alert && (<CustomAlert message={alert.message} type={alert.type} onClose={() => setAlert(null)} />)}
            <Helmet>
                <title>{process.env.REACT_APP_PERFIL} - Esteira</title>
                <link rel="icon" href={process.env.REACT_APP_FAVICON_PATH}/>
            </Helmet>

            <Routes>
                <Route element={<PublicLayout />}>
                <Route path="/:slug/login" element={<LoginComponent />} />
                <Route path="/error-originador" element={<ErroOriginador />} />
                <Route path="/login" element={<LoginComponent />} />
                </Route> 
                <Route path="/trocar-senha" element={<LoginAlteracaoSenhaComponent />} />

                <Route
                    path="/:slug?"
                    element={
                        <PrivateRoute>
                            <LayoutProvider>
                                <ThemedLayout />
                            </LayoutProvider>
                        </PrivateRoute>
                    }
                >
                    <Route index element={<Navigate to="home" replace />} />
                    <Route path="home" element={<Home />} />
                    <Route path="sem-permissao" element={<SemPermissao />} />
        
                    
                    {/* PROPOSTA */}
                    <Route path="proposta-cartao" element={<CartaoComponent />} />
                    {/* ESTEIRA */}
                    <Route path="esteira-proposta/:tipoTela" element={<PropostasComponent />} />
                    <Route path="esteira-cliente/alteracao" element={<ClienteComponent />} />
                    <Route path="esteira-proposta/atividades" element={<EsteiraAtividades />} />
                    <Route path="proposta-esteira-component" element={<PropostaEsteiraComponent />} />
                    <Route path="proposta-reemissao-ccb" element={<PropostaReemissaoCcbComponent />} />
                    <Route path="gestao-documentoscopia" element={<GestaoDocComponent />} />
                    <Route path="analise-rmc" element={<AnaliseRmcComponent />} />
                    <Route path="esteira-consulta-documentos" element={<ConsultaDocumentosComponent />} />
                    <Route path="esteira-retorno-fluxo" element={<RetornoFluxoComponent />} />
                    <Route path="esteira-reprovar-proposta" element={<ReprovarPropostaComponent />} />
                    <Route path="esteira-controle-bloqueio" element={<ControleBloqueioComponent />} />
                    {/* CLIENTE */}
                    <Route path="cliente-consulta/:tipoTela" element={<ClienteConsultaComponent />} />
                    <Route path="cliente-consulta-historico" element={<ClienteConsultaHistoricoComponent />} />
                    <Route path="cliente-aprovar-atualizacao" element={<ClienteAprovarAtualizacaoComponent />} />
                    <Route path="cliente-relatorio" element={<ClienteRelatorioComponent />} />
                    {/* RELATORIOS */}
                    <Route path="relatorio-analitico" element={<ProducaoAnaliticoComponent />} />
                    <Route path="relatorio-sintetico" element={<ProducaoSinteticoComponent />} />
                    <Route path="relatorio-origens-cadastradas" element={<OrigensCadastradasComponent />} />
                    <Route path="relatorio-extrato-mensal" element={<ExtratoMensalComponent />} />
                    <Route path="relatorio-fatores-price" element={<RelatorioFatorPriceComponent />} />
                    <Route path="gerenciador-relatorios" element={<GerenciadorRelatoriosComponent />} />
                    <Route path="relatorios-layout" element={<RelatoriosPersonalizadosComponent />} />
                    <Route path="relatorios-personalizados" element={<RelatoriosPersonalizadosInclusaoAlteracao />} />
                    <Route path="relatorio-conciliacao" element={<Conciliacao />} />
                    {/* ORIGENS */}
                    <Route path="origens-matriz" element={<MatrizComponent />} />
                    <Route path="origens-matriz/:tipo" element={<MatrizInclusaoAlteracao />} />
                    <Route path="origens-promotora" element={<PromotoraComponent />} />
                    <Route path="origens-promotora/:tipo" element={<PromotoraInclusaoAlteracao />} />
                    <Route path="origens-supervisor" element={<SupervisorComponent />} />
                    <Route path="origens-supervisor/:tipo" element={<SupervisorInclusaoAlteracao />} />
                    <Route path="origens-operador" element={<OperadorComponent />} />
                    <Route path="origens-operador/:tipo" element={<OperadorInclusaoAlteracao />} />
                    <Route path="origens-ponto-venda" element={<PontoVendaComponent />} />
                    <Route path="origens-ponto-venda/:tipo" element={<PontoVendaInclusaoAlteracao />} />
                    <Route path="origens-originador" element={<OriginadorComponent />} />
                    <Route path="origens-originador/:tipo" element={<OriginadorInclusaoAlteracao />} />
                    <Route path="origens-regional" element={<RegionalComponent />} />
                    <Route path="origens-regional/:tipo" element={<RegionalInclusaoAlteracao />} />
                    <Route path="origens-comercial" element={<ComercialComponent />} />
                    <Route path="origens-comercial/:tipo" element={<ComercialInclusaoAlteracao />} />

                    {/* PARAMETROS CARTAO */}
                    <Route path="parametros-empregador" element={<EmpregadorComponent />} />
                    <Route path="parametros-empregador/:tipo" element={<EmpregadorInclusaoAlteracao />} />
                    <Route path="parametros-esteira" element={<EsteiraComponent />} />
                    <Route path="parametros-esteira/inclusao" element={<EsteiraInclusao />} />
                    <Route path="parametros-esteira/alteracao" element={<EsteiraAlteracao />} />
                    <Route path="parametros-empregador/orgao" element={<OrgaoComponent />} />
                    <Route path="parametros-produto" element={<ProdutoComponent />} />
                    <Route path="parametros-produto/:tipo" element={<ProdutoInclusaoAlteracao />} />
                    <Route path="parametros-banco" element={<BancoComponent />} />
                    <Route path="parametros-banco/:tipo" element={<BancoInclusaoAlteracao />} />
                    <Route path="parametros-financiamento" element={<FinanciamentoComponent />} />
                    <Route path="parametros-financiamento/:tipo" element={<FinanciamentoInclusaoAlteracao />} />
                    <Route path="parametros-financiamento/promotora" element={<FinanciamentoPromotora />} />
                    <Route path="parametros-financiamento/empregador" element={<FinanciamentoEmpregador />} />
                    <Route path="promotora-empregador" element={<PromotoraEmpregador />} />
                    <Route path="promotora-financiamento" element={<PromotoraFinanciamento />} />
                    <Route path="controle-rmc-informacoes-gerais" element={<PromotoraInformacoesGerais />} />
                    <Route path="motivo-recusa" element={<MotivoComponent />} />
                    <Route path="parametros-feriados" element={<FeriadosComponent />} />
                    <Route path="parametros-feriados/inclusao" element={<FeriadosInclusaoComponent/>} />
                    <Route path="parametros-feriados/edicao/:id" element={<FeriadosEdicaoComponent/>} />
                    {/* COMUNICADOS */}
                    <Route path="comunicados-vigentes" element={<ComunicadosVigentesComponent />} />
                    <Route path="comunicados-visualizacao" element={<ComunicadosVigentesVisualizacao />} />
                    <Route path="comunicados-tipos" element={<ComunicadosTipoComponent />} />
                    <Route path="comunicados" element={<ComunicadosComponent />} />
                    <Route path="comunicados/:tipo" element={<ComunicadosInclusaoAlteracao />} />
                    <Route path="comunicados-confirmacao" element={<ComunicadosConfirmacaoComponent />} />
                    {/* SISTEMA */}
                    <Route path="sistema-alcadas-esteira" element={<AlcadaEsteiraComponent />} />
                    <Route path="sistema-alcadas-esteira/:tipo" element={<AlcadaInclusaoAlteracao />} />
                    <Route path="sistema-parametros-gerais" element={<ParametrosGerais />} />
                    <Route path="sistema-parametros-ti" element={<ParametrosTi />} />
                    <Route path="sistema-usuario" element={<UsuarioComponent />} />
                    <Route path="sistema-roles" element={<RoleInclusaoComponent />} /> 
                    <Route path="sistema-roles/:tipo" element={<RoleInclusaoAlteracao />} />
                    <Route path="sistema-usuario/:tipo" element={<UsuarioInclusaoAlteracao />} />
                    <Route path="sistema-logs" element={<LogsComponent />} />
                    <Route path="sistema-integracoes" element={<IntegracaoComponent />} />
                    <Route path="sistema-integracoes/:tipoAcao" element={<IntegracaoFormComponent />} /> 
                    {/* BACKOFFICE */}
                    <Route path="backoffice-ph3a/consulta" element={<ConsultaPH3AComponent />} />
                    <Route path="backoffice-serasa/consulta" element={<SerasaConsultaComponent />} />
                    <Route path="backoffice-pep/consulta" element={<ConsultaPEPComponent />} />
                    <Route path="backoffice-contrato/consulta" element={<ConsultaContratoComponent />} />
                    <Route path="backoffice-contrato/detalhe" element={<DetalheContratoComponent />} />
                    {/* BACKOFFICE - LANCAMENTOS */}
                    <Route path="backoffice-lancamentos/    " element={<BaixaParcelaManualComponent />} />
                    <Route path="backoffice-lancamentos/baixa-parcela-financeira" element={<BaixaParcelaFinanceiraManualComponent />} />

                    <Route path="backoffice-lancamentos/baixa-parcela-financeira-empregador" element={<BaixaParcelaFinanceiraPorEmpregadorComponent />} />
                    <Route path="backoffice-contrato/prorrogacao-vencimento" element={<ProrrogacaoVencimentoManualComponent />} />
                    <Route path="backoffice-lancamentos/estorno-parcela" element={<EstornoParcelaComponent />} />
                    <Route path="backoffice-lancamentos/cancelamento-movimentacao" element={<CancelamentoMovimentacao />} />
                    <Route path="backoffice-lancamentos/estorno-operacao" element={<EstornoOperacao />} />
                    <Route path="backoffice-lancamentos/repactuacao" element={<RepactuaçãoParcelaComponent />} />
                    {/* BACKOFFICE -ARQUIVOS LOTE */}
                    <Route path="backoffice-arquivo-lote/:processamento" element={<ArquivoLoteComponent />} />
                    <Route path="backoffice-arquivo-lote/detalhe/:idArquivo" element={<ArquivoLoteDetalhe />} />
                    {/* BACKOFFICE - CESSAO */}
                    <Route path="backoffice-cessao/lancamento-manual" element={<LancamentoManual />} />
                    <Route path="backoffice-cessao/remessa-cessao" element={<RemessaCessao />} />
                    <Route path="backoffice-cessao/recompra-manual" element={<RecompraManualComponent />} />
                    <Route path="backoffice-cessao/remessa-liquidacao" element={<RemessaoLiquidacaoComponent />} />
                    <Route path="backoffice-cessao/gerenciamento-cessao" element={<GerenciamentoCessao />} />
                    {/* BACKOFFICE -RELATORIOS */}
                    <Route path="backoffice-relatorios/operacoes-realizadas" element={<OperacoesRealizadasComponent />} />
                    <Route path="backoffice-relatorios/vencimentos" element={<DeVencimentosComponent />} />
                    <Route path="backoffice-relatorios/movimentacao-financeira"element={<MovimentacaoFinanceiraComponent />} />
                    <Route path="backoffice-relatorios/movimentacao-baixa-financeira"element={<MovimentacaoBaixaFinanceiraComponent />} />
                    <Route path="backoffice-relatorios/contratos-cedidos" element={<ContratosCedidosComponent />} />
                    <Route path="backoffice-relatorios/parcelas-cedidas" element={<ParcelasCedidasComponent />} />
                    {/* BACKOFFICE - TABELAS */}
                    <Route path="backoffice-tabelas/historico-financeiro" element={<HistoricoFinanceiroComponent />} />
                    <Route path="backoffice-tabelas/historico-financeiro/:tipo" element={<HistoricoFinanceiroInclusaoAlteracao />} />
                    <Route path="backoffice-tabelas/fidc" element={<FidcComponent />} />
                    <Route path="backoffice-tabelas/fidc/:tipo" element={<FidcInlusaoAlteracao />} />
                    <Route path="backoffice-tabelas/cessao" element={<CessaoComponent />} />
                    <Route path="backoffice-tabelas/cessao/:tipo" element={<CessaoInclusaoAlteracao />} />
                    {/* PROCESSADORA CARTÃO */}
                    <Route path="processadora-cartao/rastreio-cartao" element={ <RastreamentoCartaoProcessadoraCartao /> } />
                    <Route path="processadora-cartao/consulta-limite-cartao" element={ <ConsultaLimiteProcessadoraCartao /> } />
                    <Route path="processadora-cartao/segunda-via-cartao" element={ <SolicitacaoSegundaViaCartao /> } />
                    <Route path="processadora-cartao/cancelamento-cartao" element={ <CancelamentoCartao /> } />
                    <Route path="backoffice-importacao/importacao-aquisicao" element={<ImportacaoAquisicao />} />
                    
                    {/* COMISSÃO */}
                    <Route path="comissao/notafiscal" element={<GestaoNotaFiscalComponent />} />
                    <Route path="comissao/extorno" element={<EstornoComponent />} />
                    <Route path="comissao/negociacoes" element={<NegociacoesComponent />} />
                    <Route path="comissao/regras" element={<ComissaoRegrasComponent />} />
                    <Route path="comissao/parametros" element={<ComissaoParametrosGeraisComponent />} />
                    <Route path="comissao/fatura" element={<FaturaGestaoComponent />} />
                    <Route path="comissao/tipo" element={<TipoComissaoComponent />} />
                    <Route path="comissao/financeiro" element={<FinanceiroComponent />} />
                    <Route path="comissao/relatorio-faturas" element={<RelatorioFaturasComponent />} />
                    
                    <Route path="*" element={<Navigate to="home" replace />} />
                </Route>

        <Route path="/alterar-senha" element={<PrivateRoute><UsuarioAlteracaoSenhaComponent /></PrivateRoute>} />

        {/* PROPOSTA */}
        <Route path="/proposta-cartao" element={<PrivateRoute><CartaoComponent /></PrivateRoute>} />

        {/* ESTEIRA */}
        <Route path="/esteira-proposta/:tipoTela" element={<PrivateRoute><PropostasComponent /></PrivateRoute>} />
        <Route path="/esteira-cliente/alteracao" element={<PrivateRoute><ClienteComponent /></PrivateRoute>} />
        <Route path="/esteira-proposta/atividades" element={<PrivateRoute><EsteiraAtividades /></PrivateRoute>} />
        <Route path="/proposta-esteira-component" element={<PrivateRoute><PropostaEsteiraComponent /></PrivateRoute>} />
        <Route path="/proposta-reemissao-ccb" element={<PrivateRoute><PropostaReemissaoCcbComponent /></PrivateRoute>} />
        <Route path="/gestao-documentoscopia" element={<PrivateRoute><GestaoDocComponent /></PrivateRoute>} />
        <Route path="/analise-rmc" element={<PrivateRoute><AnaliseRmcComponent /></PrivateRoute>} />
        <Route path="/esteira-consulta-documentos" element={<PrivateRoute><ConsultaDocumentosComponent /></PrivateRoute>} />
        <Route path="/esteira-retorno-fluxo" element={<PrivateRoute><RetornoFluxoComponent /></PrivateRoute>} />
        <Route path="/esteira-reprovar-proposta" element={<PrivateRoute><ReprovarPropostaComponent /></PrivateRoute>} />
        <Route path="/esteira-controle-bloqueio" element={<PrivateRoute><ControleBloqueioComponent /></PrivateRoute>} />

        {/* CLIENTE */}
        <Route path="/cliente-consulta/:tipoTela" element={<PrivateRoute><ClienteConsultaComponent /></PrivateRoute>} />
        <Route path="/cliente-consulta-historico" element={<PrivateRoute><ClienteConsultaHistoricoComponent /></PrivateRoute>} />
        <Route path="/cliente-aprovar-atualizacao" element={<PrivateRoute><ClienteAprovarAtualizacaoComponent /></PrivateRoute>} />
        <Route path="/cliente-relatorio" element={<PrivateRoute><ClienteRelatorioComponent /></PrivateRoute>} />

        {/* RELATORIOS */}
        <Route path="/relatorio-analitico" element={<PrivateRoute><ProducaoAnaliticoComponent /></PrivateRoute>} />
        <Route path="/relatorio-sintetico" element={<PrivateRoute><ProducaoSinteticoComponent /></PrivateRoute>} />
        <Route path="/relatorio-origens-cadastradas" element={<PrivateRoute><OrigensCadastradasComponent /></PrivateRoute>} />
        <Route path="/relatorio-extrato-mensal" element={<PrivateRoute><ExtratoMensalComponent /></PrivateRoute>} />
        <Route path="/relatorio-fatores-price" element={<PrivateRoute><RelatorioFatorPriceComponent /></PrivateRoute>} />
        <Route path="/gerenciador-relatorios" element={<PrivateRoute><GerenciadorRelatoriosComponent /></PrivateRoute>} />

        {/* ORIGENS */}
        <Route path="/origens-matriz" element={<PrivateRoute><MatrizComponent /></PrivateRoute>} />
        <Route path="/origens-matriz/:tipo" element={<PrivateRoute><MatrizInclusaoAlteracao /></PrivateRoute>} />

        <Route path="/origens-promotora" element={<PrivateRoute><PromotoraComponent /></PrivateRoute>} />
        <Route path="/origens-promotora/:tipo" element={<PrivateRoute><PromotoraInclusaoAlteracao /></PrivateRoute>} />

        <Route path="/origens-supervisor" element={<PrivateRoute><SupervisorComponent /></PrivateRoute>} />
        <Route path="/origens-supervisor/:tipo" element={<PrivateRoute><SupervisorInclusaoAlteracao /></PrivateRoute>} />

        <Route path="/origens-operador" element={<PrivateRoute><OperadorComponent /></PrivateRoute>} />
        <Route path="/origens-operador/:tipo" element={<PrivateRoute><OperadorInclusaoAlteracao /></PrivateRoute>} />

        <Route path="/origens-ponto-venda" element={<PrivateRoute><PontoVendaComponent /></PrivateRoute>} />
        <Route path="/origens-ponto-venda/:tipo" element={<PrivateRoute><PontoVendaInclusaoAlteracao /></PrivateRoute>} />

        {/* PARAMETROS CARTAO */}
        <Route path="/parametros-empregador" element={<PrivateRoute><EmpregadorComponent /></PrivateRoute>} />
        <Route path="/parametros-empregador/:tipo" element={<PrivateRoute><EmpregadorInclusaoAlteracao /></PrivateRoute>} />

        <Route path="/parametros-esteira" element={<PrivateRoute><EsteiraComponent /></PrivateRoute>} />
        <Route path="/parametros-esteira/inclusao" element={<PrivateRoute><EsteiraInclusao /></PrivateRoute>} />
        <Route path="/parametros-esteira/alteracao" element={<PrivateRoute><EsteiraAlteracao /></PrivateRoute>} />

        <Route path="/parametros-empregador/orgao" element={<PrivateRoute><OrgaoComponent /></PrivateRoute>} />

        <Route path="/parametros-produto" element={<PrivateRoute><ProdutoComponent /></PrivateRoute>} />
        <Route path="/parametros-produto/:tipo" element={<PrivateRoute><ProdutoInclusaoAlteracao /></PrivateRoute>} />

        <Route path="/parametros-banco" element={<PrivateRoute><BancoComponent /></PrivateRoute>} />
        <Route path="/parametros-banco/:tipo" element={<PrivateRoute><BancoInclusaoAlteracao /></PrivateRoute>} />

        <Route path="/parametros-financiamento" element={<PrivateRoute><FinanciamentoComponent /></PrivateRoute>} />
        <Route path="/parametros-financiamento/:tipo" element={<PrivateRoute><FinanciamentoInclusaoAlteracao /></PrivateRoute>} />

        <Route path="/parametros-financiamento/promotora" element={<PrivateRoute><FinanciamentoPromotora /></PrivateRoute>} />
        <Route path="/parametros-financiamento/empregador" element={<PrivateRoute><FinanciamentoEmpregador /></PrivateRoute>} />

        <Route path="/promotora-empregador" element={<PrivateRoute><PromotoraEmpregador /></PrivateRoute>} />
        <Route path="/promotora-financiamento" element={<PrivateRoute><PromotoraFinanciamento /></PrivateRoute>} />

        <Route path="/promotora-informacoes-gerais" element={<PrivateRoute><PromotoraInformacoesGerais /></PrivateRoute>} />

        <Route path="/motivo-recusa" element={<PrivateRoute><MotivoComponent /></PrivateRoute>} />

        <Route path="/parametros-feriados" element={<PrivateRoute><FeriadosComponent /></PrivateRoute>} />
        <Route path="/parametros-feriados/inclusao" element={<PrivateRoute><FeriadosInclusaoComponent/></PrivateRoute>} />
        <Route path="/parametros-feriados/edicao/:id" element={<PrivateRoute><FeriadosEdicaoComponent/></PrivateRoute>} />

        {/* COMUNICADOS */}
        <Route path="/comunicados-vigentes" element={<PrivateRoute><ComunicadosVigentesComponent /></PrivateRoute>} />
        <Route path="/comunicados-visualizacao" element={<PrivateRoute><ComunicadosVigentesVisualizacao /></PrivateRoute>} />
        <Route path="/comunicados-tipos" element={<PrivateRoute><ComunicadosTipoComponent /></PrivateRoute>} />
        <Route path="/comunicados" element={<PrivateRoute><ComunicadosComponent /></PrivateRoute>} />
        <Route path="/comunicados/:tipo" element={<PrivateRoute><ComunicadosInclusaoAlteracao /></PrivateRoute>} />
        <Route path="/comunicados-confirmacao" element={<PrivateRoute><ComunicadosConfirmacaoComponent /></PrivateRoute>} />

        {/* SISTEMA */}
        <Route path="/sistema-alcadas-esteira" element={<PrivateRoute><AlcadaEsteiraComponent /></PrivateRoute>} />
        <Route path="/sistema-alcadas-esteira/:tipo" element={<PrivateRoute><AlcadaInclusaoAlteracao /></PrivateRoute>} />
        <Route path="/sistema-parametros-gerais" element={<PrivateRoute><ParametrosGerais /></PrivateRoute>} />
        <Route path="/sistema-parametros-ti" element={<PrivateRoute><ParametrosTi /></PrivateRoute>} />
        <Route path="/sistema-usuario" element={<PrivateRoute><UsuarioComponent /></PrivateRoute>} />
        <Route path="/sistema-usuario/:tipo" element={<PrivateRoute><UsuarioInclusaoAlteracao /></PrivateRoute>} />
        <Route path="/sistema-logs" element={<PrivateRoute><LogsComponent /></PrivateRoute>} />

        {/* BACKOFFICE */}
        <Route path="/backoffice-contrato/consulta" element={<PrivateRoute><ConsultaContratoComponent /></PrivateRoute>} />
        <Route path="/backoffice-contrato/detalhe" element={<PrivateRoute><DetalheContratoComponent /></PrivateRoute>} />

        {/* BACKOFFICE - LANCAMENTOS */}
        <Route path="/backoffice-lancamentos/baixa-parcela" element={<PrivateRoute><BaixaParcelaManualComponent /></PrivateRoute>} />
        <Route path="/backoffice-lancamentos/baixa-parcela-financeira" element={<PrivateRoute><BaixaParcelaFinanceiraManualComponent /></PrivateRoute>} />
        <Route path="/backoffice-lancamentos/baixa-parcela-financeira-empregador" element={<PrivateRoute><BaixaParcelaFinanceiraPorEmpregadorComponent /></PrivateRoute>} />
        <Route path="/backoffice-contrato/prorrogacao-vencimento" element={<PrivateRoute><ProrrogacaoVencimentoManualComponent /></PrivateRoute>} />
        <Route path="/backoffice-lancamentos/estorno-parcela" element={<PrivateRoute><EstornoParcelaComponent /></PrivateRoute>} />
        <Route path="/backoffice-lancamentos/cancelamento-movimentacao" element={<PrivateRoute><CancelamentoMovimentacao /></PrivateRoute>} />
        <Route path="/backoffice-lancamentos/estorno-operacao" element={<PrivateRoute><EstornoOperacao /></PrivateRoute>} />

        {/* BACKOFFICE -ARQUIVOS LOTE */}
        <Route path="/backoffice-arquivo-lote/:processamento" element={<PrivateRoute><ArquivoLoteComponent /></PrivateRoute>} />
        <Route path="/backoffice-arquivo-lote/detalhe/:idArquivo" element={<PrivateRoute><ArquivoLoteDetalhe /></PrivateRoute>} />

        {/* BACKOFFICE - CESSAO */}
        <Route path="/backoffice-cessao/lancamento-manual" element={<PrivateRoute><LancamentoManual /></PrivateRoute>} />
        <Route path="/backoffice-cessao/remessa-cessao" element={<PrivateRoute><RemessaCessao /></PrivateRoute>} />
        <Route path="/backoffice-cessao/recompra-manual" element={<PrivateRoute><RecompraManualComponent /></PrivateRoute>} />
        <Route path="/backoffice-cessao/remessa-liquidacao" element={<PrivateRoute><RemessaoLiquidacaoComponent /></PrivateRoute>} />

        {/* BACKOFFICE -RELATORIOS */}
        <Route path="/backoffice-relatorios/operacoes-realizadas" element={<PrivateRoute><OperacoesRealizadasComponent /></PrivateRoute>} />
        <Route path="/backoffice-relatorios/vencimentos" element={<PrivateRoute><DeVencimentosComponent /></PrivateRoute>} />
        <Route path="/backoffice-relatorios/movimentacao-financeira"element={<PrivateRoute><MovimentacaoFinanceiraComponent /></PrivateRoute>} />
        <Route path="/backoffice-relatorios/baixa-financeira"element={<PrivateRoute><MovimentacaoBaixaFinanceiraComponent /></PrivateRoute>} />
        <Route path="/backoffice-relatorios/contratos-cedidos" element={<PrivateRoute><ContratosCedidosComponent /></PrivateRoute>} />
        <Route path="/backoffice-relatorios/parcelas-cedidas" element={<PrivateRoute><ParcelasCedidasComponent /></PrivateRoute>} />

        {/* BACKOFFICE - TABELAS */}
        <Route path="/backoffice-tabelas/historico-financeiro" element={<PrivateRoute><HistoricoFinanceiroComponent /></PrivateRoute>} />
        <Route path="/backoffice-tabelas/historico-financeiro/:tipo" element={<PrivateRoute><HistoricoFinanceiroInclusaoAlteracao /></PrivateRoute>} />
        <Route path="/backoffice-tabelas/fidc" element={<PrivateRoute><FidcComponent /></PrivateRoute>} />
        <Route path="/backoffice-tabelas/fidc/:tipo" element={<PrivateRoute><FidcInlusaoAlteracao /></PrivateRoute>} />
        <Route path="/backoffice-tabelas/cessao" element={<PrivateRoute><CessaoComponent /></PrivateRoute>} />
        <Route path="/backoffice-tabelas/cessao/:tipo" element={<PrivateRoute><CessaoInclusaoAlteracao /></PrivateRoute>} />
        
        {/* BACKOFFICE - IMPORTACAO */}
        <Route path="/backoffice-importacao/importacao-aquisicao" element={<PrivateRoute><ImportacaoAquisicao /></PrivateRoute>} />
        

        {/* PROCESSADORA CARTÃO */}
        <Route path="/processadora-cartao/rastreio-cartao" element={<PrivateRoute><RastreamentoCartaoProcessadoraCartao /></PrivateRoute>} />
        <Route path="/processadora-cartao/consulta-limite-cartao" element={<PrivateRoute><ConsultaLimiteProcessadoraCartao /></PrivateRoute>} />
        <Route path="/processadora-cartao/segunda-via-cartao" element={<PrivateRoute><SolicitacaoSegundaViaCartao /></PrivateRoute>} />
        <Route path="/processadora-cartao/cancelamento-cartao" element={<PrivateRoute><CancelamentoCartao /></PrivateRoute>} />
        

        <Route path="/backoffice-importacao/importacao-aquisicao" element={<PrivateRoute><ImportacaoAquisicao /></PrivateRoute>} />
        <Route path="*" element={<Navigate to="/login" replace />} />


      </Routes>
    </div>

  );
}

export default App;